import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { MasterDataCommon } from 'src/app/master-data/master-data.common';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-diary-details-client-wise',
  templateUrl: './diary-details-client-wise.component.html',
  styleUrls: ['./diary-details-client-wise.component.css']
})
export class DiaryDetailsClientWiseComponent implements OnInit {
  page = 1;
  pageSize = 10;
  pageLength = 0;
  showRow = false;
  diaryForm;
  modalForm;
  reports;
  showReports = false;
  employeeList;
  financialList;
  clientList;
  selectClient=[];
  isClientSelected=false;
  selectAssignment=[];
  assignmentList;
  isAssignmentSelected=false;
  userId;
  selectedFinancialYear;
  selectedfromDate;
  selectedtoDate;
  empType = 'Active';
  typeList = [
    { id: 1, name: 'Active' },
    { id: 0, name: 'Closed' },
  ];
  formSubmitted = false;
  formErrors = MasterDataCommon.diaryDetailsFormErrors;
  formValidationMessages = MasterDataCommon.diaryDetailsFormValidationMessages;
  empFName;
  empLName;
  fdate;
  tdate;
  // activeEmp = [];
  // closedEmp = [];
  // typeEmpList = [];
  config: any;
  collection = { count: 60, reports: [] };
  totalDebitHr;
  totalDebitMin;
  totalDebitHrMin;
  totalCreditHr;
  totalCreditMin;
  totalNoOfHr;
  totalNoOfMin;
  totalAmount;
  sumOfDebitedHours;
  sumOfCreditedHours;
  sumOfNumberOfHours;
  maxDate;
  
 

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService,
    private masterDataService: MasterDataService,
    private commonMessageService:CommonMessageService,
  ) {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.reports,
    };
  }

  
  loadFYDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  getAllClientDetails(){
    console.log(this.selectedFinancialYear)
    this.masterDataService.getAllClientByYear(this.selectedFinancialYear.id, this.userId).subscribe((resp:any)=>{
      console.log('client list',resp);
      this.clientList=resp;
    })
    }

  pageChanged(event) {
    if (this.pageLength == event) {
      this.showRow = true;
    } else {
      this.showRow = false;
    }
  }

  ngOnInit(): void {
    this.userId = localStorage.getItem('id');
    this.selectedFinancialYear = "";
    var currentDate;
    // Get the current date as a NgbDateStruct object
  currentDate= Object.assign({}, { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() });
  
  // Set the max date to the current date
  this.maxDate = currentDate;

    this.loadFYDetails();
    this.loadEmployeeProfiles();
    this.initDiaryForm();
  }

  // loadProfiles() {
  //   this.humanResourceService.getProfiles().subscribe((res: any) => {
  //     this.employeeFormList = res;
  //     for (let i = 1; i < this.employeeFormList.length; i++) {
  //       if (this.employeeFormList[i].userOfficialDetails == null || this.employeeFormList[i].userOfficialDetails.profileStatus == 1) {
  //         this.activeEmp.push(this.employeeFormList[i]);
  //       } else {
  //         this.closedEmp.push(this.employeeFormList[i]);
  //       }
  //     }
  //     this.typeEmpList = this.activeEmp;
  //   });
  // }

  // onSelectEmp() {
  //   if (this.diaryForm.value.empStatus != 'Active') {
  //     this.typeEmpList = this.closedEmp;
  //   }else{
  //     this.typeEmpList = this.activeEmp;
  //   }
  // }

  onFYSelected() {
    // this.reportList=undefined;
    // this.showExcelButton=false;
    // this.selectPartner="";
    //   this.getAllPartnerDetails();
    console.log(this.selectedFinancialYear);
    this.getAllClientDetails();
  }

  getAllAssignmentDetails(){
    this.selectAssignment=[];
    if(this.selectClient.length>0 && this.selectedFinancialYear!=""){
    const clientId = this.selectClient.map(({ id }) => id);
    this.masterDataService.getAllAssignment(this.selectedFinancialYear.id,clientId, this.userId).subscribe((resp:any)=>{
      console.log('Assignment List',resp);
      this.assignmentList=resp;
    });
  }
  }

  selectAllClient(select: NgModel, values) {
    console.log('inside select client method',this.selectAssignment);
    this.selectAll(select, values, this.isClientSelected);
    this.isClientSelected = !this.isClientSelected;
    this.getAllAssignmentDetails();
  }

  selectAllAssignment(select: NgModel, values){
    this.selectAll(select, values, this.isAssignmentSelected);
    this.isAssignmentSelected = !this.isAssignmentSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  loadEmployeeProfiles(){
    console.log('empType',this.empType);
    var changeEmpType;
    if(this.empType=='Active'){
      changeEmpType=1;
    }else{
      changeEmpType=0;
    }
    this.humanResourceService.getEmployeeProfile(changeEmpType).subscribe((res: any) => {
      this.employeeList = res;
      console.log('employee list',this.employeeList);
  });
}

  initDiaryForm() {
    this.diaryForm = this.fb.group({
      finacialYear: ['', [Validators.required, Validators.maxLength(50)]],
      client: ['', [Validators.required, Validators.maxLength(50)]],
      fromDate: ['', [Validators.required]],
      toDate: ['', [Validators.required]],
    });
  }

  onViewReport() {
    this.showRow = false;
    this.formSubmitted = true;

    this.logValidationErrors(this.diaryForm);

    if (this.diaryForm.valid) {
      this.page = 1;
      console.log('inside view report Method');
      this.fdate =
        this.diaryForm.value.fromDate.year +
        '-' +
        this.diaryForm.value.fromDate.month +
        '-' +
        this.diaryForm.value.fromDate.day;
      this.tdate =
        this.diaryForm.value.toDate.year +
        '-' +
        this.diaryForm.value.toDate.month +
        '-' +
        this.diaryForm.value.toDate.day;

      this.empFName = this.diaryForm.value.employee.firstName;
      this.empLName = this.diaryForm.value.employee.lastName;
      this.reports = [];
      this.diaryReportService.getDiaryDetailsReport(this.diaryForm).subscribe(
        (resp) => {
          this.reports = resp;
          this.showReports = true;
          console.log('After view report response', this.reports, this.showReports);
          this.pageLength = Math.ceil(this.reports.length / 10);
          if (this.pageLength == 1) {
            this.showRow = true;
          } else {
            this.showRow = false;
          }
          this.fndTotalCount(this.reports);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  fndTotalCount(report) {
    this.totalDebitHr = 0;
    this.totalDebitMin = 0;
    this.totalDebitHrMin = 0;
    this.totalCreditHr = 0;
    this.totalCreditMin = 0;
    this.totalNoOfHr = 0;
    this.totalNoOfMin = 0;
    this.totalAmount = 0;

    for (let i = 0; i < report.length; i++) {
      this.totalDebitHr += report[i].debitHrs;
      this.totalDebitMin += report[i].debitMin/60;

      this.totalCreditHr += report[i].creditHrs;
      this.totalCreditMin += report[i].creditMin/60;

      this.totalNoOfHr += report[i].noOfHoursHr;
      this.totalNoOfMin += report[i].noOfHoursMin/60;

      this.totalAmount += report[i].amount;
    }
    this.sumOfDebitedHours=this.totalDebitHr+this.totalDebitMin;
    this.sumOfDebitedHours=this.convertToHoursAndMinutes(this.sumOfDebitedHours);
    this.sumOfCreditedHours=this.totalCreditHr+this.totalCreditMin;
    this.sumOfCreditedHours=this.convertToHoursAndMinutes(this.sumOfCreditedHours);
    this.sumOfNumberOfHours=this.totalNoOfHr+this.totalNoOfMin;
    this.sumOfNumberOfHours=this.convertToHoursAndMinutes(this.sumOfNumberOfHours);
    // this.totalDebitMin=this.totalDebitMin>=60?this.totalDebitMin/60:this.totalDebitMin;
    // this.totalCreditMin=this.totalCreditMin>=60?this.totalCreditMin/60:this.totalCreditMin;
    // this.totalNoOfMin=this.totalNoOfMin>=60?this.totalNoOfMin/60:this.totalNoOfMin;
    console.log('reportlength', report.length);

  }

  convertToHoursAndMinutes(floatNum: number) {
    const hours = Math.floor(floatNum);
    const minutes = Math.round((floatNum - hours) * 60);
    var temp = String(hours)+"."+String(minutes); 
    return temp;
  }

  onFromDateChange(fromDate) {
    var formatFromDate = new Date(fromDate.year+'-'+fromDate.month+'-'+fromDate.day);
    this.selectedfromDate=moment(formatFromDate).format('YYYY-MM-DD');
     console.log('fromDate',this.selectedfromDate);
   }
 
   onToDateChange(toDate) {
     var FormatToDate=new Date(toDate.year+'-'+toDate.month+'-'+toDate.day);
     this.selectedtoDate=moment(FormatToDate).format('YYYY-MM-DD');
     console.log('toDate',this.selectedtoDate);
   }

  exportToExcelClick(){
    console.log("export");
    const clientId = this.selectClient.map(({ id }) => id);
    const assignmentId = this.selectAssignment.map(({ id }) => id);
    if(this.selectClient.length>0 && this.selectAssignment.length>0 && this.selectedfromDate!=null && this.selectedtoDate!=null)
   { 
    
        this.diaryReportService.getDiaryReportsClientWiseExportToExcelAPI(clientId,assignmentId,this.selectedfromDate,this.selectedtoDate).subscribe(
    
      (resp:any) => {
        if(resp.size>2)
        {
          console.log("response:",resp)
          const blob = new Blob([resp]); // you can change the type
        var downloadURL= window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "DiaryReportClientWise.xlsx";
        link.click();
      }
      else
      {
        this.commonMessageService.swalAlertWithoutIcon('','No records found!.');
      }
      });
    }
    else{
      this.commonMessageService.swalAlertWithoutIcon('','Please select mandatory fields.');
    }   
  }
}
